export default {
  placeholder: 'Select a recipe',
};
